import { render, staticRenderFns } from "./ruleDivisionDropDown.vue?vue&type=template&id=217d85d4&scoped=true"
import script from "./ruleDivisionDropDown.vue?vue&type=script&lang=js"
export * from "./ruleDivisionDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217d85d4",
  null
  
)

export default component.exports